export default {
  namespaced: true,
  state: {
    sitecode: '200',
    loading: {
      getData: false,
      createKarte: false,
      deleteKarte: false,
      getAllKarte: false,
    },
    saving: false,
    offline: false,
    offlineHideAlert: false,
    store: {
      v: 0,
      settings: {
      },
    },
  },
  getters: {
  },
  mutations: {
    offlineHideAlert(state) {
      state.offlineHideAlert = true;
    },
    setLoading(state, { name, value }) {
      state.loading[name] = value;
    },
    setStateStore(state, { name, val }) {
      state.store[name] = val;
    },
    deleteKarte(state, idKind) {
      if (
        state.store.kinder
          .filter((o) => o.id === String(idKind))
          .length > 0
      ) {
        state.store.kinder
          .filter((o) => o.id === idKind)[0]
          .dokumente.forEach((dok, idx) => {
            if (dok.id === 'IDCard') {
              state.store.kinder
                .filter((o) => o.id === idKind)[0]
                .dokumente.splice(idx, 1);
            }
          });
      }
    },
    addKarte(state, { idKind, karte }) {
      if (
        state.store.kinder
          .filter((o) => o.id === String(idKind))
          .length > 0
      ) {
        state.store.kinder
          .filter((o) => o.id === idKind)[0]
          .dokumente.push(karte);
      }
    },
  },
  actions: {
    async tryPostAPI({ state, commit }, {
      url, func, data,
    }) {
      commit('setLoading', { name: func, value: true });
      let help = {};
      const cacheKey = `f${state.sitecode}-${url}?${func}`;
      try {
        const body = new FormData();
        body.append('code', this.state.login.session.code);
        const requestData = data && typeof data === 'object' ? data : {};
        Object.keys(requestData).forEach((k) => {
          let value = requestData[k];
          const isBlob = typeof Blob !== 'undefined' && value instanceof Blob;
          if (value !== null && typeof value === 'object' && !isBlob) {
            value = JSON.stringify(value);
          }
          body.append(k, value === null || typeof value === 'undefined' ? '' : value);
        });
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
          try {
            const parsed = JSON.parse(cached);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) help = parsed;
          } catch (cacheError) {
            localStorage.removeItem(cacheKey);
          }
        }
        const result = await fetch(`${process.env.VUE_APP_API_HOST}/${url}?${func}`, {
          method: 'POST',
          body,
        });
        const responseText = await result.text();
        let response;
        try {
          response = JSON.parse(responseText);
        } catch (parseError) {
          throw new Error('Der Server hat keine gueltige JSON-Antwort geliefert.');
        }
        if (!response || typeof response !== 'object' || Array.isArray(response)) {
          throw new Error('Der Server hat keine gueltige JSON-Antwort geliefert.');
        }
        if (response.status === 'accessError') {
          this.commit('login/backendErrorSession');
          return false;
        }
        if (!result.ok || ['forbidden', 'validationError', 'error', 'serverError']
          .includes(response.status)) {
          this.commit('main/alert', {
            typ: 'error',
            text: response.message || 'Die Aktion konnte nicht ausgeführt werden.',
          });
          return false;
        }
        if (func === 'getData') {
          if (response.save && typeof response.save === 'object' && !Array.isArray(response.save)) {
            help = response.save;
          }
          localStorage.setItem(cacheKey, JSON.stringify(help));
        } else if (func === 'getAllKarte') {
          if (Number(response.count) > 0 && typeof response.path === 'string') {
            const downloaded = await this.dispatch('main/tryDownload', {
              path: response.path,
              name: 'Karten.pdf',
              newTab: true,
            });
            return downloaded;
          }
          this.commit('main/alert', {
            typ: 'error',
            text: 'Keine Karten gefunden. Bitte die Auswahl überprüfen',
          });
          return false;
        }
        return true;
      } catch (error) {
        this.commit('main/alert', {
          typ: 'error',
          text: 'Bitte die Netzwerkverbindung prüfen.',
        });
        return false;
      } finally {
        commit('setLoading', { name: func, value: false });
        if (func === 'getData') {
          try {
            localStorage.setItem(cacheKey, JSON.stringify(help));
          } catch (cacheError) {
            /* Der aktuelle Arbeitsspeicher bleibt auch ohne Browsercache nutzbar. */
          }
          Object.keys(help).forEach((k) => {
            commit('setStateStore', { name: k, val: help[k] });
          });
        }
      }
    },
  },
};
